import { useQuery } from '@apollo/client';

import { experimentsQuery, ExperimentsResponse } from './Experiments.helpers';

export const useExperiments = () => {
  const { data: experiments } = useQuery<ExperimentsResponse>(experimentsQuery);

  return experiments?.experiments || [];
};
